import { render, staticRenderFns } from "./OurServiceTable.vue?vue&type=template&id=74352fae&scoped=true"
import script from "./OurServiceTable.vue?vue&type=script&lang=js"
export * from "./OurServiceTable.vue?vue&type=script&lang=js"
import style0 from "./OurServiceTable.vue?vue&type=style&index=0&id=74352fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74352fae",
  null
  
)

export default component.exports